<template>
  <div
    v-cloak
    v-loading.fullscreen.lock="dataLoading"
    element-loading-text="Loading, please wait..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >



    <confirmation-box ref="deleteAbstractDialog" @handleConfirm="confirmToremove"></confirmation-box>

    <confirmation-box ref="deleteInstanceDialog" @handleConfirm="confirmToremoveInstance"></confirmation-box>

    <add-abstract-tag
      :abstractParentId="abstractParentId"
      ref="addAbstractTagDialog"
      @saveSuccess="getAbstractTree"
    ></add-abstract-tag>

    <edit-abstract-tag
      ref="editAbstractTagDialog"
      :editAbstractTagDO="editAbstractTagDO"
      @saveSuccess="getAbstractTree"
    ></edit-abstract-tag>

    <add-instance-tag
      :instanceParentId="instanceParentId"
      :abstractTagId ="chooseAbstractTagId"
      ref="addInstanceTagDialog"
      @saveSuccess="getInstanceTree"
    ></add-instance-tag>

    <edit-instance-tag
      ref="editInstanceTagDialog"
      :editInstanceTagDO="editInstanceTagDO"
      @saveSuccess="getInstanceTree"
    ></edit-instance-tag>

    <div class="tab">
      <el-row style="margin:0 30px 0 0">
        <p class="describe-title" style="border-bottom: #ccc 1px solid;padding-bottom:5px">
          Tag Instance依赖于Tag Abstract, Tag Abstract的改动会导致Tag Instance的刷新。
        </p>
      </el-row>
      <el-row>
        <el-col :span="11" style="float:left">
          <h5>Tag Abstract</h5>
          <el-row>
            <p class="describe-title">是一种对资源的抽象</p>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="area">
                <div class="area-1">
                  <el-row :gutter="20" class="mp">
                    <el-col :span="18" class="mp">
                      <el-form
                        ref="queryForm"
                        label-width="100px"
                        label-position="right"
                        class="mp"
                      >
                        <el-form-item label="功能名称：" class="mp">
                          <!--prop校验-->
                          <el-input v-model="searchAbstractValue" size="small" class="mp"></el-input>
                        </el-form-item>
                      </el-form>
                    </el-col>
                    <el-col :span="6">
                      <div class="text-left button-auto" style="margin-top: 3px;">
                        <el-button
                          type="primary"
                          size="mini"
                          @click="searchForAbstractTree()"
                        >Search</el-button>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20" class="mp">
                    <el-col :span="23">
                      <div class="text-right button-auto2" style="margin-bottom: 10px;">
                        <el-button
                          type="primary"
                          size="mini"
                          @click="addAbstractTag()"
                          :disabled="addAbstractDisabled"
                        >Add</el-button>
                        <el-button
                          type="primary"
                          size="mini"
                          @click="editAbstractTag()"
                          :disabled="editAbstractDisabled"
                        >Edit Selected</el-button>
                        <!-- <el-button type="primary" size="mini" @click="saveAbstractStructure()">Save Structure</el-button>-->
                        <el-button
                          type="danger"
                          size="mini"
                          @click="deleteAbstractTag()"
                          :disabled="deleteAbstractDisabled"
                        >Delete Checked List</el-button>
                      </div>
                    </el-col>
                  </el-row>
                </div>
                <div class="area-2 area-left">
                  <el-row :gutter="20" class="mp" style="background: #58ba58 !important;">
                    <el-col style="width:100%;padding:0px">
                      <tree-control
                        :draggable="false"
                        ref="abstractTree"
                        :showCheckbox="showAbstractCheckbox"
                        @nodeClick="abstractNodeClick"
                      ></tree-control>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-col>

        <el-col :span="11" style="float:right;margin-right:30px">
          <h5>Tag Instance</h5>
          <el-row>
            <p class="describe-title">对资源数据的分组</p>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="area">
                <div class="area-1">
                  <el-row :gutter="20" class="mp">
                    <el-col :span="18" class="mp">
                      <el-form ref="queryForm" label-width="100px" label-position="right">
                        <el-form-item label="功能名称：" class="mp">
                          <!--prop校验-->
                          <el-input v-model="searchInstanceValue" size="small"></el-input>
                        </el-form-item>
                      </el-form>
                    </el-col>
                    <el-col :span="6">
                      <div class="text-left button-auto" style="margin-top: 3px;">
                        <el-button
                          type="primary"
                          size="mini"
                          @click="searchForInstanceTree()"
                        >Search</el-button>
                      </div>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20" class="mp">
                    <el-col :span="23">
                      <div class="text-right button-auto2" style="margin-bottom: 10px;">
                        <el-button
                          type="primary"
                          size="mini"
                          @click="addInstanceTag()"
                          :disabled="addInstanceDisabled"
                        >Add</el-button>
                        <el-button
                          type="primary"
                          size="mini"
                          @click="editInstanceTag()"
                          :disabled="editInstanceDisabled"
                        >Edit Selected</el-button>
                        <!--                        <el-button type="primary" size="mini" @click="saveInstanceStructure()">Save Structure</el-button>-->
                        <el-button
                          type="danger"
                          size="mini"
                          @click="deleteInstanceTag()"
                          :disabled="deleteInstanceDisabled"
                        >Delete Checked List</el-button>
                      </div>
                    </el-col>
                  </el-row>
                </div>
                <div class="area-2 area-right">
                  <el-row :gutter="20" class="mp">
                    <!-- 由于信息显示不全，添加滚动条 -->
                    <el-col style="width:620px;padding:0px;overflow: auto;">
                      <tree-control
                        :draggable="false"
                        ref="instanceTree"
                        :showCheckbox="showInstanceCheckBox"
                        @nodeClick="instanceNodeClick"
                      ></tree-control>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import confirmationBox from "@/components/dialog/confirmation_box.vue";
  import treeControl from "@/view/acs/tree/tree_control.vue";
  import treeSelect from "@/view/acs/tree/tree_selection.vue";

  import addAbstractTag from "@/view/acs/tag/dialog/add_abstract_tag.vue";
  import editAbstractTag from "@/view/acs/tag/dialog/edit_abstract_tag.vue";

  import addInstanceTag from "@/view/acs/tag/dialog/add_instance_tag.vue";
  import editInstanceTag from "@/view/acs/tag/dialog/edit_instance_tag.vue";

  // import instanceTagTable from '@/view/acs/tag/dialog/instance_tag_table.vue'

  export default {
    props: {},
    components: {
      editAbstractTag,
      addAbstractTag,
      confirmationBox,
      treeControl,
      treeSelect,
      addInstanceTag,
      editInstanceTag
      // instanceTagTable
    },
    data() {
      return {
        searchAbstractValue: "",
        dataLoading: false,
        activeNames: ["1"],
        showAbstractCheckbox: false,
        abstractParentId: "0",
        chooseAbstractTagId:'',
        editAbstractTagDO: {},
        searchInstanceValue: "",
        showInstanceCheckBox: false,
        instanceParentId: "0",
        editInstanceTagDO: {},
        addInstanceDisabled: true,
        editInstanceDisabled: true,
        deleteInstanceDisabled: true,
        addAbstractDisabled: false,
        editAbstractDisabled: true,
        deleteAbstractDisabled: true,
        aData: "",
        iData: "",
        clickAbstractRow: {},
        clickInstanceRow: {}
      };
    },
    computed: {},
    created() {
      this.initTree();
    },
    mounted() {
      let tree_structure = document.getElementsByClassName("el-tree");
      tree_structure[0].style.backgroundColor = "#ddd";
      tree_structure[1].style.backgroundColor = "#eee";
    },
    methods: {
      initTree() {
        // @TODO： instance-tree
        let abstractUrl =
          this.baseAcsUrl + "/acs/data-abstract-tag/get-tree";
        let instanceUrl =
          this.baseAcsUrl + "/acs/data-instance-tag/get-tree";
        let that = this;
        this.dataLoading = true;
        this.axios
          .all([that.http.get(abstractUrl), that.http.get(instanceUrl)])
          .then(
            this.axios.spread(function(abstractResp, instanceResp) {
              that.dataLoading = false;
              let abstractData = abstractResp.data;
              // that.aData = abstractData;
              // console.log("aData",that.aData);
              let instanceRespData = instanceResp.data;
              // that.iData = instanceRespData;
              if (abstractData) {
                that.$refs.abstractTree.initTree(abstractData, "tagName","isService");
              }
              if (instanceRespData) {
                that.$refs.instanceTree.initTree(instanceRespData, "tagName","isService");
              }
            })
          )
          .catch(error => {
            console.error(error);
            that.dataLoading = false;
          });
      },
      getAbstractTree() {
        this.$emit("abstractChange");
        let url = this.baseAcsUrl + "/acs/data-abstract-tag/get-tree";
        this.dataLoading = true;
        this.http
          .get(url)
          .then(resp => {
            //this.structure = resp.data;
            this.$refs.abstractTree.initTree(resp.data, "tagName");
            // console.log(resp.data)
            //   console.log("重新请求了数据a");
            this.aData = resp.data;
            this.dataLoading = false;
          })
          .catch(error => {
            this.dataLoading = false;
            console.info(error);
          });
      },
      getInstanceTree() {
        let url = this.baseAcsUrl + "/acs/data-instance-tag/get-tree";
        this.dataLoading = true;
        this.http
          .get(url)
          .then(resp => {
            //this.structure = resp.data;
            this.$refs.instanceTree.initTree(resp.data, "tagName");
            this.iData = resp.data;
            this.dataLoading = false;
          })
          .catch(error => {
            this.dataLoading = false;
            //   console.info(error);
            console.log("重新请求了数据i");
          });
      },

      abstractNodeClick(data) {
        // Nothing to do
        //   console.log(data);
        // this.addAbstractDisabled = data.id == 0;
        this.editAbstractDisabled = data.id == 0;
        this.deleteAbstractDisabled = data.id == 0;
        this.clickAbstractRow = data;
      },
      searchForAbstractTree() {
        this.$refs.abstractTree.filter(this.searchAbstractValue);
      },
      searchForInstanceTree() {
        this.$refs.instanceTree.filter(this.searchInstanceValue);
      },

      addAbstractTag() {
        this.abstractParentId = this.$refs.abstractTree.getFunctionNodeKey();
        this.$refs.addAbstractTagDialog.showDialog();
      },
      editAbstractTag() {
        this.editAbstractTagDO = this.$refs.abstractTree.getCurrentNode();
        this.$refs.editAbstractTagDialog.showDialog();
      },
      saveAbstractStructure() {
        let dataStructure = this.$refs.abstractTree.getDataStructure();
        let url = this.baseAcsUrl + "/acs/data-abstract-tag/update";

        if (!dataStructure && dataStructure.length == 0) {
          this.$message.warning("Please save at least one record");
          return;
        }
        for (let i in dataStructure) {
          dataStructure[i].abstractParentId = null;
        }
        this.dataLoading = true;
        this.http
          .put(url, dataStructure)
          .then(resp => {
            this.$message.success("Successful operation ");
            this.$emit("changeAbstract");
            this.getAbstractTree();
            this.dataLoading = false;
          })
          .catch(error => {
            this.dataLoading = false;
            console.info(error);
          });
      },
      deleteAbstractTag() {
        this.$refs.deleteAbstractDialog.showDialog();
      },
      confirmToremove() {
        let idObj = { id: this.clickAbstractRow.id };
        console.log("idObj", idObj);
        let url = this.baseAcsUrl + "/acs/data-abstract-tag/delete";
        this.dataLoading = true;
        this.http
          .delete(url, idObj)
          .then(resp => {
            this.dataLoading = false;
            this.$refs.deleteAbstractDialog.hideDialog();
            this.$message.success("Successful operation");
            this.getAbstractTree();
          })
          .catch(error => {
            this.dataLoading = false;
            console.info(error);
          });
      },
      confirmToremoveInstance() {
        let idObj = { id: this.clickInstanceRow.id };
        let url = this.baseAcsUrl + "/acs/data-instance-tag/delete";
        this.dataLoading = true;
        this.http
          .delete(url, idObj)
          .then(resp => {
            this.dataLoading = false;
            this.$refs.deleteInstanceDialog.hideDialog();
            this.$message.success("Successful operation");
            this.getInstanceTree();
          })
          .catch(error => {
            this.dataLoading = false;
            console.error(error);
          });
      },
      addInstanceTag() {
        this.instanceParentId = this.$refs.instanceTree.getCurrentNode().instanceParentId;
        this.chooseAbstractTagId = this.$refs.instanceTree.getCurrentNode().abstractTagId;
        this.$refs.addInstanceTagDialog.showDialog();
      },
      editInstanceTag() {
        this.editInstanceTagDO = this.$refs.instanceTree.getCurrentNode();
        this.$refs.editInstanceTagDialog.showDialog();
      },
      saveInstanceStructure() {
        let dataStructure = this.$refs.instanceTree.getDataStructure();
        console.log(dataStructure);
      },
      deleteInstanceTag() {
        this.$refs.deleteInstanceDialog.showDialog();
      },
      instanceNodeClick(nodeData) {
        // Nothing to do
        //   console.log(nodeData);
        this.addInstanceDisabled = nodeData.isService != 0;
        this.editInstanceDisabled = nodeData.isService != 2;
        this.deleteInstanceDisabled = nodeData.isService != 2;
        this.clickInstanceRow = nodeData;
        //
        // let abstractTagId = '';
        //
        // let getNextNodeUrl = this.baseAcsUrl + "/acs/data-instance-tag/get-data-tag-tab";
        // if(nodeData.isService == 1 || nodeData.id == 0){
        //   return;
        //
        //
        // }else if(nodeData.isService == 0){
        //
        //
        // }else{
        //   abstractTagId = nodeData.id;
        //
        // }
        // getNextNodeUrl += "?data_tag_id =" + abstractTagId;
        //
        // this.dataLoading = true;
        // this.http.get(getNextNodeUrl).then(resp =>{
        //   let data = resp.data;
        //   if(data){
        //     nodeData.children =data;
        //     console.log(nodeData);
        //   }
        //   this.dataLoading =false;
        //
        // }).catch(error =>{
        //   console.error(error);
        //   this.dataLoading =false;
        // })
      },
      reload() {
        console.log(this.$forceUpdate);
        this.$forceUpdate();
      }
    },
    watch: {
      aData: {
        deep: true,
        handler(newV, oldV) {
          if (newV != oldV) {
            this.initTree();
          }
        }
      }
    }
  };
</script>
<style scoped>
  .el-input--small .el-input__inner {
    height: 25px;
    line-height: 25px;
  }
  .el-button--mini,
  .el-button--small {
    height: 25px;
  }
  .el-form-item__content,
  .el-form-item__label {
    line-height: 30px;
  }
</style>
<style lang="scss" scoped>
  .mp {
    margin: 0 !important;
    padding: 0 !important;
  }
  h5 {
    font-weight: 600;
    margin: 0;
    padding: 5px 0 10px 0;
  }

  .describe-title {
    margin: 0;
    font-size: 12px;
  }

  [v-cloak] {
    display: none;
  }
  .breadcrumb {
    background-color: transparent !important;
    margin-bottom: 0px;
  }
  .title {
    margin-left: 16px;
    font-size: 20px;
  }
  .tab {
    background: #fff;
    margin: 0 10px;
    padding-left: 10px;
    height: 570px;
    min-width: 770px;
    overflow-x: auto;
  }
  .area {
    min-width: 345px;
    margin-top: 10px;
    border: 1px solid #d1dbe5;
    border-radius: 4px;
    background-color: #f6f8f9;
    font-size: 10px;
    .area-2 {
      height: 380px;
      // background: #58a;
      width: 100%;
      overflow: hidden;
      overflow-y: auto;
      overflow-x: auto;
      /* 设置滚动条的样式 */
      &::-webkit-scrollbar {
        width: 5px;
        background-color: #fff;
      }
      /* 滚动槽 */
      &::-webkit-scrollbar-track {
        // border-radius:10px;
      }

      /* 滚动条滑块 */
      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        // background:#f6f8f9;
        background: #ccc;
      }
    }
    .area-left {
      background: #ddd;
    }
    .area-right {
      background: #eee;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/acs/tag/dialog/tag_list3.vue